import { render, staticRenderFns } from "./FinancialByIdTable.vue?vue&type=template&id=72058e4e&"
import script from "./FinancialByIdTable.vue?vue&type=script&lang=js&"
export * from "./FinancialByIdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports